import Head from 'expo-router/head';

import { VisuallyHiddenH1 } from '@fhs/ui';
import { StoreLocator } from '@fhs-legacy/frontend/src/pages/store-locator';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

function StoreLocatorPage() {
  return (
    <>
      <Head>
        <title>Find a Firehouse - Firehouse Subs</title>
      </Head>
      <VisuallyHiddenH1 title="Store Locator" />
      <StoreLocator />
    </>
  );
}

export default StoreLocatorPage;
